import React from "react";
import { useNavigate } from "react-router-dom";
import NavigationIcon from '../../../assets/logos/back-nav.svg'

const BackNavigation = ({
    label = "Back to homepage",
    to = -1, // default: go back
    className = "",
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(to);
    };

    return (
        <div
            onClick={handleClick}
            className={`back-nav ${className}`}
            style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#333",
                fontSize: "14px",
                gap: "8px",
            }}
        >
            <img src={NavigationIcon} alt="Back Icon" />
            <span>{label}</span>
        </div>
    );
};

export default BackNavigation;